import * as React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import UpdateIcon from '@mui/icons-material/Update';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import CurrencyBitcoinIcon from '@mui/icons-material/CurrencyBitcoin';
import LanOutlinedIcon from '@mui/icons-material/LanOutlined';
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

const roadmapItems = [
  {
    icon: <IntegrationInstructionsIcon />,
    title: 'Phase One',
    heading: 'Foundation & Preparation',
    description: 'Strategic planning, branding, and infrastructure setup to enable autonomous operations.',
  },
  {
    icon: <UpdateIcon />,
    title: 'Phase Two',
    heading: 'Task Scheduling & Feedback',
    description: 'Implement a robust scheduling system that automates task coordination and delivers real-time updates for seamless operations.',
  },
  {
    icon: <SmartToyOutlinedIcon />,
    title: 'Phase Three',
    heading: 'Autonomous Marketing Launch',
    description: 'Deploy AI-driven marketing tools for automated campaign management and customer engagement.',
  },
  {
    icon: <LanOutlinedIcon />,
    title: 'Phase Four',
    heading: 'Blockchain Operations Integration',
    description: 'Automate blockchain tasks including token launches, liquidity pool creation, airdrops, and presales management.',
  },
  {
    icon: <CurrencyBitcoinIcon />,
    title: 'Phase Five',
    heading: 'Autonomous Trading & Portfolio Management',
    description: 'Leverage real-time portfolio analysis and automated trading strategies for optimal cryptocurrency performance.',
  },
  {
    icon: <InsightsRoundedIcon />,
    title: 'Phase Six',
    heading: 'Platform Optimization & Scaling',
    description: 'Continuous enhancements, advanced analytics, and scaling improvements to maximize efficiency.',
  },
];

export default function Roadmap() {
  return (
    <Box
      id="roadmap"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        color: 'white',
        bgcolor: 'grey.900',
      }}
    >
      <Container
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 3, sm: 6 },
        }}
      >
        {/* Header Section */}
        <Box
          sx={{
            width: { sm: '100%', md: '60%' },
            textAlign: { sm: 'left', md: 'center' },
          }}
        >
          <Typography component="h2" variant="h4" gutterBottom>
            Roadmap
          </Typography>
          <Typography variant="body1" sx={{ color: 'grey.400' }}>
            Follow Viva’s journey as we revolutionize the digital landscape with autonomous solutions for marketing, blockchain operations, and cryptocurrency trading. From foundational setup to advanced AI-driven automation, explore our roadmap and witness our commitment to efficiency and innovation.
          </Typography>
        </Box>

        {/* Timeline */}
        <Timeline position="alternate">
          {roadmapItems.map((item, index) => (
            <TimelineItem key={index}>
              <TimelineOppositeContent
                sx={{ m: 'auto 0' }}
                align="right"
                variant="body2"
                color="text.secondary"
              >
                {item.title}
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot color="primary">{item.icon}</TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: '12px', px: 2 }}>
                <Typography variant="h6" component="span">
                  {item.heading}
                </Typography>
                <Typography>{item.description}</Typography>
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      </Container>
    </Box>
  );
}